module.exports = __webpack_public_path__ + "static/FAQ_stage-899bf5720f765080440c5588d3fa281f.jpg";